import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { LabResearchTab } from '@pages/donor-detail/ui/LabResearchTab'

function LabResearchRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <LabResearchTab visitId={visitId} basePath="/donors" />
    </Suspense>
  )
}

export const Route = createFileRoute(
  '/_protected/donors/$visitId/lab-research/',
)({
  component: LabResearchRoute,
})
